import(/* webpackMode: "eager" */ "/app/src/app/[locale]/page.js");
